import { render } from "./DriverBusDetails.vue?vue&type=template&id=33db5c90&scoped=true"
import script from "./DriverBusDetails.vue?vue&type=script&lang=js"
export * from "./DriverBusDetails.vue?vue&type=script&lang=js"

import "./DriverBusDetails.vue?vue&type=style&index=0&id=33db5c90&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33db5c90"]])

export default __exports__